import React from 'react';
import TravelAgentReports from './TravelAgentReports';
import './App.css';

function App() {
  return (
    <div className="App">
      <TravelAgentReports />
    </div>
  );
}

export default App;
